/**
 * O título e o subtítulo de cada tela do painel, pelo caminho.
 *
 * Espelha as rotas do `AppSidebar` e do `DrawerMobile`. Quem lê é o cabeçalho mobile, que
 * mostra o título, e o feedback das telas (M-281), que manda o título junto com o caminho
 * para o admin saber de que tela o usuário falava.
 */
export interface TituloDaTela {
  title: string;
  subtitle: string;
}

export const TITULOS_DAS_TELAS: Record<string, TituloDaTela> = {
  "/dashboard": { title: "Visão Geral", subtitle: "Dashboard consolidado" },
  "/": { title: "Visão Geral", subtitle: "Dashboard consolidado" },
  "/dashboard/google-analytics": {
    title: "Google Analytics",
    subtitle: "Análise de usuários",
  },
  "/dashboard/products": {
    title: "Produtos",
    subtitle: "Gestão de produtos",
  },
  "/dashboard/conversion-rate": {
    title: "Taxa de Conversão",
    subtitle: "Análise de conversões",
  },
  "/dashboard/acquisition": {
    title: "Aquisição",
    subtitle: "Canais de aquisição",
  },
  "/dashboard/analise-pedidos": {
    title: "Análise de Pedidos",
    subtitle: "Cada pedido e a origem que o trouxe",
  },
  "/dashboard/ads": { title: "ADS", subtitle: "Performance de anúncios" },
  "/dashboard/utm": { title: "UTM", subtitle: "Rastreamento de campanhas" },
  "/dashboard/pages": { title: "Páginas", subtitle: "Análise de páginas" },
  "/dashboard/receita": { title: "Receita", subtitle: "Análise de receita" },
  "/dashboard/regiao": { title: "Região", subtitle: "Dados por região" },
  "/dashboard/seo": { title: "SEO", subtitle: "Otimização para buscas" },
  "/dashboard/instagram": {
    title: "Instagram",
    subtitle: "Métricas do Instagram",
  },
  "/dashboard/historico": {
    title: "Histórico",
    subtitle: "Dados históricos",
  },
  "/dashboard/media-performance": {
    title: "Performance Geral",
    subtitle: "Performance de mídia",
  },
  "/dashboard/meta-ads": { title: "Meta Ads", subtitle: "Anúncios Meta" },
  "/dashboard/google-ads": {
    title: "Google Ads",
    subtitle: "Anúncios Google",
  },
  "/dashboard/search-console": {
    title: "Search Console",
    subtitle: "Dados do Search Console",
  },
  "/dashboard/integrations": {
    title: "Integrações",
    subtitle: "Configurações",
  },
  "/dashboard/my-account": {
    title: "Minha Conta",
    subtitle: "Configurações da conta",
  },
  "/dashboard/accounts": {
    title: "Contas da Agência",
    subtitle: "Gestão de contas",
  },
  "/dashboard/ai-insights": {
    title: "Insights IA",
    subtitle: "Análises inteligentes",
  },
  "/dashboard/health": {
    title: "Status",
    subtitle: "Status das integrações",
  },
  "/dashboard/alerts": { title: "Alertas", subtitle: "Notificações" },
  "/dashboard/account": {
    // <M-249> "Meu Perfil", e não "Conta": "Minha Conta" é a outra tela.
    title: "Meu Perfil",
    subtitle: "Seus dados, senha e sessões",
  },
  "/dashboard/analise-diaria": {
    title: "Análise Diária",
    subtitle: "Performance diária",
  },
  "/dashboard/analise-mensal": {
    title: "Análise Mensal",
    subtitle: "Performance mensal",
  },
  "/dashboard/detalhamento-etapa-1": {
    title: "Detalhamento Etapa 1",
    subtitle: "Topo, meio e fundo do investimento em mídia",
  },
  "/dashboard/analise-ticket-medio": {
    title: "Ticket Médio",
    subtitle: "Análise de ticket médio",
  },
  "/dashboard/melhores-resultados-meta": {
    title: "Melhores Resultados",
    subtitle: "Top resultados Meta",
  },
  "/dashboard/benchmark": {
    title: "Benchmark",
    subtitle: "Comparação com o mercado",
  },
  "/dashboard/media-chat": {
    title: "Arquiteto",
    subtitle: "Perguntas sobre vendas e mídia",
  },
  "/dashboard/diagnostico": {
    title: "Diagnóstico",
    subtitle: "Auditoria da loja",
  },
  "/dashboard/teams": { title: "Times", subtitle: "Times da agência" },
  "/dashboard/account-selection": {
    title: "Escolher Loja",
    subtitle: "Contas da agência",
  },
};

/**
 * O título da tela no caminho, ou `null` para uma rota que o mapa não conhece.
 *
 * A rota com parâmetro (`/dashboard/teams/:teamId`) não está no mapa e herda o título da tela
 * mãe (`Times`). A herança para antes de `/dashboard`: uma rota desconhecida não é a Visão
 * Geral.
 */
export const tituloDaTela = (caminho: string): string | null => {
  const exato = TITULOS_DAS_TELAS[caminho]?.title;
  if (exato !== undefined) return exato;
  const mae = caminho.replace(/\/[^/]+\/?$/, "");
  if (mae === caminho || mae === "/dashboard" || mae === "") return null;
  return tituloDaTela(mae);
};
